export enum UserAuthProviderTypeEnum {
  LINE = 'line',
  TWITTER = 'twitter',
  ASP_OSTIARIES = 'asp-ostiaries',
  EMAIL= 'email',
  GOOGLE= 'google',
  ID_PW= 'id-pw',
  ZALO='zalo'
}
